import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { environment } from '../../../../environments/environment';

@Component({
    selector: 'app-ach',
    templateUrl: './ach.component.html',
    styleUrls: ['./ach.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class ACHComponent implements OnInit {

    achBfSettingsValue = ""
    achBfSettingsId: number = null

    constructor(
        private http: HttpClient,
        private toastrService: ToastrService
    ) { }

    ngOnInit() {
        this.getAchEnvironmentSettings(); 
    }

    getAchEnvironmentSettings() {
        this.http
            .get<any[]>(`${environment.dotNetApiUrl}/Core/EnvironmentSettings/GetByCategoryAndEnvironment?settingCategory=BFSettings`)
            .subscribe((response) => {
                if (response && response.length > 0) {
                    const index = response.findIndex(x => x.settingName == "ACHFormat")
                    if (index != -1) {
                        this.achBfSettingsId = response[index].id;
                        this.achBfSettingsValue = response[index].settingValue;
                    }
                }
            },
                (err) => {
                    console.error('Error:', err);
                });
    }

    patchAchEnvironmentSettings() {
        if (this.achBfSettingsId) {
            this.http.patch<any>(`${environment.dotNetApiUrl}/Core/EnvironmentSettings/PatchValue?environmentId=${this.achBfSettingsId}&value=${this.achBfSettingsValue}`, {})
                .subscribe((x) => {
                    this.toastrService.success("ACH BF setting changed successfully.")
                },
                    (err) => {
                        this.toastrService.error("ACH BF setting failed to change.")
                        console.error('Error:', err);
                    });
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/developer/system-settings/ach/ach.component.ts